import React, { useEffect, useState } from "react";
import styles from "./../checkout.module.css";
import OtpInput from "react-otp-input";
import { encryptedData, onlyNumber } from "../../../constant/utils";
import { checkOutAction } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

interface IBooking {
  bookingData: any;
  setBookingData: (val: any) => void;
}
const LoginVerify = ({ bookingData, setBookingData }: IBooking) => {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState<string>("");
  const [otp, setOtp] = useState<string>("");
  const [error, setError] = useState<any>("");
  const [login, setLogin] = useState<boolean>(false);
  const [seconds, setSeconds] = useState(30);
  const [sendOtp, setSendOtp] = useState<any>({});
  

  const checkoutLoading: boolean = useSelector(
    (state: any) => state.checkout.checkoutLoading || false,
  );
  const handleMobileChange = (e: any) => {
    setOtp("");
    setSeconds(0);
    setMobile(e.target.value);
  };

  useEffect(() => {
    localStorage.removeItem("ocq:noneHomeCollectionMsg");
    return () => {};
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const handleLogin = () => {
    if (!mobile) {
      setError("Mobile Number is required");
    } else if (mobile && mobile?.length != 10) {
      setError("Enter 10 Digit");
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      setError("Enter Valid Number");
    } else {
      setOtp("");
      dispatch(
        checkOutAction.sendOtpAction({ MobileNo: mobile }, (loginData: any) => {
          if (loginData?.UserId) {
            setSendOtp(loginData);
            setLogin(true);
            setSeconds(30);
          }
        }),
      );
    }
  };

  const handleVerifyOtp = () => {
    if (otp == "") {
      toast.error("Please fill OTP code.");
    } else {
      let Payload: any = {
        MobileNo: mobile,
        UserId: sendOtp?.UserId,
        Otp: otp,
      };
      let data = { Payload: encryptedData(JSON.stringify(Payload)) };
      let base64 = btoa(JSON.stringify(Payload));
      dispatch(
        checkOutAction.verifyOtpAction(
          { Payload: base64 },
          mobile,
          () => {
            setOtp("");
            window.location.reload();


           
          },
          () => {
            setOtp("");
          },
        ),
      );
    }
  };

  return (
    <div className={styles.paddingbox}>
      <div className="row">
        <div className="col-md-6">
          {!login && (
            <React.Fragment>
              <div className={styles.loginInp}>
                <div>Enter Mobile Number</div>
                
                <input
                  className="from-control"
                  placeholder="10 digit mobile number"
                  onKeyPress={onlyNumber}
                  maxLength={10}
                  onChange={handleMobileChange}
                  value={mobile}
                />
                {error && <div className="error_message">{error}</div>}
                {sendOtp?.error?.MobileNo && (
                  <span className="error_message">
                    {sendOtp?.error?.MobileNo[0]}
                  </span>
                )}
              </div>
         
              <button
                type="button"
                className="book--hexagon active"
                style={{ padding: "6px 25px" }}
                onClick={handleLogin}
                disabled={checkoutLoading}
              >
                <span className="text-capitalize">Continue</span>
              </button>
             
            </React.Fragment>
          )}
          {login && (
            <React.Fragment>
              <div className={styles.verifyText}>
                Please enter verification code(OTP) sent to: +91 {mobile}{" "}
                <span onClick={() => setLogin(false)}>Change Number</span>
              </div>
              <OtpInput
                numInputs={4}
                isInputNum={true}
                inputStyle={{
                  width: "36px",
                  height: "36px",
                  borderWidth: 0,
                  borderWidthBottom: "1px",
                  borderBottom: "1px solid #404040",
                }}
                value={otp}
                onChange={(val: any) => setOtp(val)}
                containerStyle={{ gap: "10px", color: "#404040" }}
              />
              {/* {otp === "" && (
    <p className={styles.promptText}>
      Please fill in the OTP code.
    </p>
  )} */}
              <p className={styles.resendText}>
                If you didn't receive a code!{" "}
                {seconds > 0 ? (
                  " Resend in"
                ) : (
                  <span onClick={handleLogin}> Resend</span>
                )}
                <span id="counter" style={{ color: "#0054A5" }}>
                  {seconds > 0 &&
                    ` 0:${seconds < 10 ? `0${seconds}` : seconds}`}
                </span>
              </p>
              <button
                type="button"
                className="book--hexagon active"
                style={{ padding: "6px 30px" }}
                onClick={handleVerifyOtp}
                disabled={checkoutLoading}
              >
                <span className="text-capitalize">Verify</span>
              </button>
            </React.Fragment>
          )}
        </div>
        <div className="col-md-6">
          <div className={styles.secureLogin}>
            <h6>Advantage of our secure login</h6>
            <div>
              <img src="/assets/img/star.png" alt="" />
              <span>We safeguard patient's data.</span>
            </div>
            <div>
              <img src="/assets/img/star.png" alt="" />
              <span>We ensure compliance.</span>
            </div>
            <div>
              {" "}
              <img src="/assets/img/star.png" alt="" />
              <span>We prevent unauthorized access.</span>
            </div>
            <div>
              {" "}
              <img src="/assets/img/star.png" alt="" />
              <span>We maintain an audit trail.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginVerify;
